module.exports = __webpack_public_path__ + "img/video-mobile.6ec72faf.png";